import { useEffect } from 'react';
import { useShow, useGo } from '@refinedev/core';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import type { ChannelMembership } from './types';

/**
 * ChannelMembershipsShow
 *
 * Редирект на страницу пользователя с открытым членством.
 * Вся функциональность управления членством теперь находится
 * в компоненте UserChannelMemberships на странице пользователя.
 */
export function ChannelMembershipsShow() {
  const { id } = useParams<{ id: string }>();
  const go = useGo();

  const showResult = useShow<ChannelMembership>({
    resource: 'channel-memberships',
    id,
  });

  const membership = showResult.query?.data?.data;
  const isError = showResult.query?.isError ?? false;

  useEffect(() => {
    if (membership?.userId) {
      // Редирект на страницу пользователя с открытым членством
      go({
        to: `/users/show/${membership.userId}?tab=access&membership=${id}`,
        type: 'replace',
      });
    }
  }, [membership, id, go]);

  if (isError) {
    return (
      <div className="flex flex-col items-center justify-center p-8 gap-4">
        <p className="text-muted-foreground">Членство не найдено</p>
        <button
          onClick={() => go({ to: '/channel-memberships' })}
          className="text-primary hover:underline"
        >
          Вернуться к списку
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-8">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      <span className="ml-2 text-muted-foreground">Перенаправление...</span>
    </div>
  );
}
